// extracted by mini-css-extract-plugin
export default {"preview":"styles_preview__SOCBJ","location":"styles_location__C+u5L","icon":"styles_icon__-w+ZA","playersNumber":"styles_playersNumber__zOyvC"};